<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'qrcode';
import {
  getLoginResult
} from "@/api/api";

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data() {
    return {
      timerId: null,
      loginUuid: null
    };
  },
  mounted() {
    console.log('App mounted');
    this.getWechatQrCode();
    let self = this
    this.timerId = setInterval(() => {
      self.getLoginResult()
    },3000);
  },
  beforeDestroy() {
    // 清除 setTimeout
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    getWechatQrCode() {
      this.loginUuid = uuidv4();
      let text = 'https://virbac-cms-stg.warnny.com/api/wechat/authorize?uniLoginId=' + this.loginUuid;
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, text, { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('QR Code generated!');
      });
    },
    getLoginResult() {
      if(!this.loginUuid) {
        console.error('Login UUID is not set');
        return;
      }
      let self = this
      getLoginResult({uniLoginId:this.loginUuid}).then(res => {
        if (res.data && res.data.userInfo) {
          console.log('Login successful');
          clearInterval(this.timerId);
          self.timerId = null;
        } else {
          console.log('Login failed');
        }
      }).catch(error => {
        console.error('Error fetching login result:', error);
      });
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
